<template>
  <section
    class="hero-section"
    :style="{ backgroundImage: 'url(/assets/background.png)' }"
  >
    <!-- Center-fade overlay so edges show the bg image -->
    <div class="hero-overlay" />
    <v-container
      style="
        max-width: 1100px;
        position: relative;
        z-index: 1;
        text-align: center;
      "
    >
      <!-- Headline -->
      <h1 class="hero-headline anim anim-1">
        {{ $t("hero.headLine1") }}
      </h1>

      <!-- Subtext -->
      <p class="hero-subtext anim anim-2">{{ $t("hero.subtext") }}</p>

      <!-- Search bar -->
      <div class="search-wrap anim anim-3">
        <v-icon class="search-icon" color="#aaa" size="20">mdi-magnify</v-icon>
        <input
          class="search-input"
          type="text"
          :placeholder="$t('hero.searchPlaceholder')"
        />
        <button
          class="search-btn"
          @click="
            $swal.fire({
              text: 'Сургуулиа бүртгүүлж, нэвтрэx эрx авсанаар үйчилгээ аваx боломжтой',
              icon: 'info',
              confirmButtonText: 'Ойлголоо',
              confirmButtonColor: '#3BD081',
              didOpen: (popup) => { popup.querySelector('.swal2-confirm').style.color = 'white' },
            })
          "
        >
          <v-icon color="white" size="20">mdi-magnify</v-icon>
        </button>
      </div>

      <!-- Inline stats -->
      <div class="stats-row anim anim-4">
        <div class="stat-item">
          <div class="stat-icon-wrap">
            <v-icon color="primary" size="20">mdi-file-document-outline</v-icon>
          </div>
          <div>
            <p class="stat-val">{{ $t("hero.stat1Val") }}</p>
            <p class="stat-lbl">{{ $t("hero.stat1Label") }}</p>
          </div>
        </div>
        <div class="stat-divider" />
        <div class="stat-item">
          <div class="stat-icon-wrap">
            <v-icon color="primary" size="20">mdi-school-outline</v-icon>
          </div>
          <div>
            <p class="stat-val">{{ $t("hero.stat2Val") }}</p>
            <p class="stat-lbl">{{ $t("hero.stat2Label") }}</p>
          </div>
        </div>
        <div class="stat-divider" />
        <div class="stat-item">
          <div class="stat-icon-wrap">
            <v-icon color="primary" size="20">mdi-earth</v-icon>
          </div>
          <div>
            <p class="stat-val">{{ $t("hero.stat3Val") }}</p>
            <p class="stat-lbl">{{ $t("hero.stat3Label") }}</p>
          </div>
        </div>
      </div>

      <!-- CTA buttons -->
      <div class="cta-row anim anim-5">
        <v-btn
          color="primary"
          depressed
          large
          rounded
          class="cta-primary px-8"
          @click="dialog = true"
        >
          {{ $t("hero.cta1") }}
        </v-btn>
        <v-btn
          outlined
          large
          rounded
          class="cta-secondary px-7"
          @click="dialog = true"
        >
          <v-icon left size="18">mdi-play-circle-outline</v-icon>
          {{ $t("hero.cta2") }}
        </v-btn>
      </div>

      <!-- Trust row -->
      <div class="trust-row anim anim-6">
        <p class="trust-text">
          {{ $t("hero.trustPrefix") }}
          <span class="trust-highlight">{{ $t("hero.trustHighlight") }}</span>
          {{ $t("hero.trustSuffix") }}
        </p>
        <div class="stars mt-1">
          <v-icon v-for="n in 5" :key="n" color="#FFB800" size="18"
            >mdi-star</v-icon
          >
        </div>
      </div>
    </v-container>

    <!-- Registration Dialog -->
    <v-dialog v-model="dialog" max-width="480" persistent>
      <v-card style="border-radius: 20px; padding: 8px">
        <v-card-title class="dialog-title pt-6 px-6 my-4"
          >Сургуулиа бүртгүүлэх</v-card-title
        >
        <v-card-subtitle class="dialog-sub px-6 pb-4"
          >Мэдээллийг бөглөж бидэнтэй холбогдоорой.</v-card-subtitle
        >
        <v-card-text class="px-6">
          <v-text-field
            v-model="form.school"
            label="Сургуулийн нэр"
            outlined
            dense
            rounded
            class="mb-2"
            prepend-inner-icon="mdi-school-outline"
          />
          <v-text-field
            v-model="form.phone"
            label="Утасны дугаар"
            outlined
            dense
            rounded
            class="mb-2"
            prepend-inner-icon="mdi-phone-outline"
            type="tel"
          />
          <v-text-field
            v-model="form.email"
            label="И-мэйл хаяг"
            outlined
            dense
            rounded
            prepend-inner-icon="mdi-email-outline"
            type="email"
          />
        </v-card-text>
        <v-card-actions class="px-6 pb-6" style="gap: 10px">
          <v-btn
            text
            rounded
            class="flex-grow-1"
            @click="dialog = false"
            style="text-transform: none; color: #888"
            >Цуцлах</v-btn
          >
          <v-btn
            color="primary"
            depressed
            rounded
            class="flex-grow-1"
            @click="dialog = false"
            style="text-transform: none; font-weight: 700"
            >Илгээх</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
export default {
  name: "HeroSection",
  data() {
    return {
      dialog: false,
      form: { school: "", phone: "", email: "" },
    };
  },
};
</script>

<style scoped>
/* ── Section ─────────────────────────────────── */
.hero-section {
  background-size: cover;
  background-position: center top;
  background-repeat: no-repeat;
  position: relative;
  height: 914px;
  display: flex;
  align-items: center;
  padding: 80px 16px 60px;
}

/* Radial overlay: white in center, transparent at edges so bg image shows */
.hero-overlay {
  position: absolute;
  inset: 0;
  background: radial-gradient(
    ellipse 75% 90% at 50% 55%,
    rgba(255, 255, 255, 0.94) 0%,
    rgba(255, 255, 255, 0.8) 40%,
    rgba(255, 255, 255, 0.2) 75%,
    rgba(255, 255, 255, 0) 100%
  );
  z-index: 0;
}

/* ── Entrance animations ─────────────────────── */
@keyframes fade-up {
  from {
    opacity: 0;
    transform: translateY(24px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.anim {
  opacity: 0;
  animation: fade-up 0.6s cubic-bezier(0.16, 1, 0.3, 1) forwards;
}
.anim-1 {
  animation-delay: 0.05s;
}
.anim-2 {
  animation-delay: 0.15s;
}
.anim-3 {
  animation-delay: 0.25s;
}
.anim-4 {
  animation-delay: 0.35s;
}
.anim-5 {
  animation-delay: 0.45s;
}
.anim-6 {
  animation-delay: 0.55s;
}

/* ── Headline ────────────────────────────────── */
.hero-headline {
  font-size: 4.8rem;
  font-weight: 900;
  line-height: 1.12;
  color: #4055af;
  letter-spacing: -2px;
  margin-bottom: 20px;
}

@media (max-width: 768px) {
  .hero-headline {
    font-size: 2.4rem;
    letter-spacing: -1px;
  }
}

.accent-pink {
  background: linear-gradient(135deg, #e91e8c, #f06292);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.accent-orange {
  background: linear-gradient(135deg, #ff6d00, #ffab40);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

/* ── Subtext ─────────────────────────────────── */
.hero-subtext {
  font-size: 1.05rem;
  color: #6b7280;
  line-height: 1.75;
  max-width: 620px;
  margin: 0 auto 32px;
}

/* ── Search bar ──────────────────────────────── */
.search-wrap {
  display: flex;
  align-items: center;
  background: white;
  border: 1.5px solid #e5e7eb;
  border-radius: 100px;
  padding: 6px 6px 6px 18px;
  max-width: 580px;
  margin: 0 auto 36px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.07);
  transition: border-color 0.2s, box-shadow 0.2s;
}

.search-wrap:focus-within {
  border-color: #3BD081;
  box-shadow: 0 4px 24px rgba(66, 87, 178, 0.14);
}

.search-icon {
  flex-shrink: 0;
  margin-right: 10px;
}

.search-input {
  flex: 1;
  border: none;
  outline: none;
  font-size: 0.95rem;
  color: #374151;
  background: transparent;
  font-family: inherit;
  min-width: 0;
}

.search-input::placeholder {
  color: #9ca3af;
}

.search-btn {
  width: 44px;
  height: 44px;
  border-radius: 100px;
  background: #3BD081;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.2s, transform 0.15s;
}

.search-btn:hover {
  background: #3348a0;
  transform: scale(1.05);
}

/* ── Stats row ───────────────────────────────── */
.stats-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 28px;
  margin-bottom: 36px;
  flex-wrap: wrap;
}

.stat-item {
  display: flex;
  align-items: center;
  gap: 10px;
}

.stat-icon-wrap {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #eef0fb;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.stat-val {
  font-size: 1rem;
  font-weight: 800;
  color: #1a1a2e;
  margin: 0;
  line-height: 1.2;
  letter-spacing: -0.3px;
  text-align: left;
}

.stat-lbl {
  font-size: 0.75rem;
  color: #9ca3af;
  margin: 0;
  font-weight: 500;
  text-align: left;
}

.stat-divider {
  width: 1px;
  height: 32px;
  background: #e5e7eb;
}

@media (max-width: 480px) {
  .stat-divider {
    display: none;
  }
}

/* ── CTA row ─────────────────────────────────── */
.cta-row {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  flex-wrap: wrap;
  margin-bottom: 32px;
}

.cta-primary {
  text-transform: none !important;
  font-size: 1rem !important;
  font-weight: 700 !important;
  letter-spacing: 0 !important;
  height: 52px !important;
  box-shadow: 0 4px 20px rgba(66, 87, 178, 0.35) !important;
}

.cta-secondary {
  text-transform: none !important;
  font-size: 1rem !important;
  font-weight: 600 !important;
  letter-spacing: 0 !important;
  height: 52px !important;
  color: #374151 !important;
  border-color: #d1d5db !important;
}

/* ── Trust row ───────────────────────────────── */
.trust-row {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.trust-text {
  font-size: 0.9rem;
  color: #6b7280;
  margin: 0;
  font-weight: 500;
}

.trust-highlight {
  color: #4257b2;
  font-weight: 700;
}

.stars {
  display: flex;
  gap: 2px;
}

.dialog-title {
  font-size: 1.3rem;
  font-weight: 800;
  color: #1a1a2e;
  letter-spacing: -0.3px;
}

.dialog-sub {
  font-size: 0.9rem;
  color: #888;
}
</style>
